import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n']);

import styled from 'styled-components';

var SkeletonNavigationItems = styled.div(_templateObject);

SkeletonNavigationItems.displayName = 'SkeletonNavigationItems';
export default SkeletonNavigationItems;